import PageLayout from '@/components/feature/PageLayout';

export default function Exteriors() {
  return (
    <PageLayout>
      <div className="bg-black pt-4 md:pt-8 pb-16 md:pb-24">
        <div className="max-w-6xl mx-auto px-6 md:px-10">

          {/* Titre principal */}
          <div className="text-center mb-[4.55rem] md:mb-[6.5rem] pt-16 md:pt-24">
            <h1 className="font-heading text-5xl md:text-7xl text-white leading-none text-center mx-auto px-4 max-w-full md:max-w-3xl">
              Les réalisations en espaces extérieurs seront dévoilées prochainement
            </h1>
          </div>

        </div>
      </div>
    </PageLayout>
  );
}